"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNAUTHENTICATED_USER_GAME_DATA = exports.RESET_STATE = exports.UPDATE_TYPE_HISTORY_FILTER = exports.FETCH_HISTORY_META = exports.GET_NGL_SESSION = exports.SET_NGL_TOKEN = exports.START_NGL_GAME_SESSION_FUN = exports.START_NGL_GAME_FUN = exports.END_NGL_GAME_FUN = exports.START_NGL_GAME_SESSION = exports.END_NGL_GAME = exports.GET_NGL_GAME_DATA = exports.START_NGL_GAME = exports.PLAY_FOR_FUN = exports.GET_ARCADE_DENOMINATIONS = exports.END_DIGITAL_REVEAL_ARCADE = exports.GET_DIGITAL_REVEAL_ARCADE = exports.DEBIT_ARCADE = exports.RESET_ARCADE = exports.GET_ARCADE = exports.GET_ARCADE_REWARD = exports.GET_ARCADE_GAMES = void 0;
const GET_ARCADE_GAMES = 'arcade/GET_ARCADE_GAMES';
exports.GET_ARCADE_GAMES = GET_ARCADE_GAMES;
const GET_ARCADE_REWARD = 'arcade/GET_ARCADE_REWARD';
exports.GET_ARCADE_REWARD = GET_ARCADE_REWARD;
const GET_ARCADE = 'arcade/GET_ARCADE';
exports.GET_ARCADE = GET_ARCADE;
const DEBIT_ARCADE = 'arcade/DEBIT_ARCADE';
exports.DEBIT_ARCADE = DEBIT_ARCADE;
const GET_DIGITAL_REVEAL_ARCADE = 'arcade/GET_DIGITAL_REVEAL_ARCADE';
exports.GET_DIGITAL_REVEAL_ARCADE = GET_DIGITAL_REVEAL_ARCADE;
const END_DIGITAL_REVEAL_ARCADE = 'arcade/END_DIGITAL_REVEAL_ARCADE';
exports.END_DIGITAL_REVEAL_ARCADE = END_DIGITAL_REVEAL_ARCADE;
const GET_ARCADE_DENOMINATIONS = 'arcade/GET_ARCADE_DENOMINATIONS';
exports.GET_ARCADE_DENOMINATIONS = GET_ARCADE_DENOMINATIONS;
const PLAY_FOR_FUN = 'arcade/PLAY_FOR_FUN';
exports.PLAY_FOR_FUN = PLAY_FOR_FUN;
const RESET_ARCADE = 'arcade/RESET_ARCADE';
exports.RESET_ARCADE = RESET_ARCADE;
const GET_NGL_GAME_DATA = 'arcade/GET_NGL_GAME_DATA';
exports.GET_NGL_GAME_DATA = GET_NGL_GAME_DATA;
const START_NGL_GAME_SESSION = 'arcade/START_NGL_GAME_SESSION';
exports.START_NGL_GAME_SESSION = START_NGL_GAME_SESSION;
const START_NGL_GAME = 'arcade/START_NGL_GAME';
exports.START_NGL_GAME = START_NGL_GAME;
const END_NGL_GAME = 'arcade/END_NGL_GAME';
exports.END_NGL_GAME = END_NGL_GAME;
const START_NGL_GAME_SESSION_FUN = 'arcade/START_NGL_GAME_SESSION_FUN';
exports.START_NGL_GAME_SESSION_FUN = START_NGL_GAME_SESSION_FUN;
const START_NGL_GAME_FUN = 'arcade/START_NGL_GAME_FUN';
exports.START_NGL_GAME_FUN = START_NGL_GAME_FUN;
const END_NGL_GAME_FUN = 'arcade/END_NGL_GAME_FUN';
exports.END_NGL_GAME_FUN = END_NGL_GAME_FUN;
const SET_NGL_TOKEN = 'arcade/SET_NGL_TOKEN';
exports.SET_NGL_TOKEN = SET_NGL_TOKEN;
const GET_NGL_SESSION = 'arcade/GET_NGL_SESSION';
exports.GET_NGL_SESSION = GET_NGL_SESSION;
const FETCH_HISTORY_META = 'arcade/FETCH_HISTORY_META';
exports.FETCH_HISTORY_META = FETCH_HISTORY_META;
const UPDATE_TYPE_HISTORY_FILTER = 'arcade/UPDATE_TYPE_HISTORY_FILTER';
exports.UPDATE_TYPE_HISTORY_FILTER = UPDATE_TYPE_HISTORY_FILTER;
const RESET_STATE = 'arcade/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
const UNAUTHENTICATED_USER_GAME_DATA = 'arcade/UNAUTHENTICATED_USER_GAME_DATA';
exports.UNAUTHENTICATED_USER_GAME_DATA = UNAUTHENTICATED_USER_GAME_DATA;
//# sourceMappingURL=types.js.map